import request from "@/utils/request";
const resource = '/resource'

export function getActivity(data){
  return request({
    url: resource + '/v3/public/event',
    data,
    methods:'get'
  })
}
export  function getActivityLoop(){
  return request({
    url:resource+'/v3/public/notice',
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/view/activityCenter/activity.js